export const MSA_SETTINGS_JPG_85 = '_FMjpg_QL85_';
